import React from 'react';
import PropTypes from 'prop-types';
import ReactButton from 'react-bootstrap/Button';
// eslint-disable-next-line no-unused-vars
import buttoncss from './button.css';

const Button = ({ onClick, title, variant, className }) => (
  <>
    <ReactButton
      className={
        className ? 'civil-debt-button ' + className : 'civil-debt-button'
      }
      variant={variant || 'button'}
      onClick={onClick}
    >
      {title}
    </ReactButton>
  </>
);

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  variant: PropTypes.string,
  className: PropTypes.string,
};

export default Button;
